import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Busy Rooms**
 *
 * @exports bs_240
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isBatschariPalaceHomepage = thn.data.propertyId === 1046889 && !window.location.hostname.includes('direct-reservation');

  /**
     * @memberOf module:bs_240
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {
    const $ = window.jQuery;
    let $desktopModal;
    let $mobileModal;

    // [Desktop] Booking confirmed modal
    if (!thn.brDesktopModalObv) {

      $desktopModal = $ && $('#bookingOverview-modal');

      if ($desktopModal && $desktopModal.length) {

        // Define page update function
        thn.brDesktopModalObv = thn.debounce(function thnBrDesktopModalObv() {
          if ($desktopModal.find('.finalBookingOverview:visible').length) {
            thn.pageCheck();
          }
        }, 250);

        // Start observation
        thn.observeDom($desktopModal.get(0), thn.brDesktopModalObv, {
          childList: true,
          subtree: true,
          characterData: false,
          attributes: true,
          attributeFilter: ['style', 'class'],
        });

        thn.shutdown(function () {
          thn.stopObserveDom($desktopModal.get(0), thn.brDesktopModalObv);
          delete thn.brDesktopModalObv;
        });
      }
    }

    // [Mobile] Booking confirmed modal
    if (!thn.brMobileModalObv) {

      $mobileModal = $ && $('#mBookingResult-modal');

      if ($mobileModal && $mobileModal.length) {

        // Define page update function
        thn.brMobileModalObv = thn.debounce(function thnBrMobileModalObv() {
          if ($mobileModal.is(':visible')) {
            thn.pageCheck();
          }
        }, 250);

        // Start observation
        thn.observeDom($mobileModal.get(0), thn.brMobileModalObv, {
          childList: false,
          subtree: false,
          characterData: false,
          attributes: true,
          attributeFilter: ['style', 'class'],
        });

        thn.shutdown(function () {
          thn.stopObserveDom($mobileModal.get(0), thn.brMobileModalObv);
          delete thn.brMobileModalObv;
        });
      }
    }

    if (isBatschariPalaceHomepage) {
      const undelegate = thn.delegate('click', '[id*=wg]', function () {
        setTimeout(thn.languageCheck, 300);
      });

      thn.shutdown(function () {
        undelegate();
        delete undelegate();
      });
    }
  };

  /**
     * @memberOf module:bs_240
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/reservation/);
    // https://jagdhaus-wiese.direct-reservation.net/api?directQuery=true&dateFrom=2024-12-03&dateTo=2024-12-05&adults=2&childrenAges=&languageCode=ES&currencyCode=EUR

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    url.pathname = '/api';
    url.searchParams.set('directQuery', 'true');
    url.searchParams.set('dateFrom', '[date_begin]');
    url.searchParams.set('dateTo', '[date_end]');
    url.searchParams.set('adults', '[adults]');
    url.searchParams.set('childrenAges', ctx.roomsDispo?.childrenAges?.join(',') || '');
    url.searchParams.set('languageCode', '[language]');
    url.searchParams.set('currencyCode', '[currency]');
    ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
    ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
    // Website is SPA and there's no way to load a page with variables
    // It has been requested to redirect to the "noresults" page for this property (save search).
    if (thn.data.propertyId === 1014159) {
      ctx.newUrl = `https://hotel-i31.direct-reservation.net/${ctx.newData.language}/noresults`;
    }

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_240
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      let lang;

      if (window.location.hostname === 'www.sentidoasterias.com') {
        lang = window.klaroConfig && thn.objectGet(window.klaroConfig, 'lang');
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      if (isBatschariPalaceHomepage) {
        lang = document.querySelector('.wgcurrent')?.dataset?.l || document.documentElement.lang;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      lang = window.location.pathname.match(ctx.urlRe);
      if (lang && ctx.langs.test(lang[1])) {
        resolve(lang[1]);
        return;
      }
      reject('no_language');
    });
  };

  engine.getPromocode = function getPromocode(ctx) {
    const promoInput = document.querySelector('#login-promocode');

    if (promoInput) {
      ctx.promocode = promoInput.value;
    }

    return ctx.promocode;
  };

  /**
     * @memberOf module:bs_240
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const $ = window.jQuery;
    let $pageLoading;

    // Some pages display a full blank loading page
    if (!thn.busyRoomsObserver) {

      $pageLoading = $ && $('.loading-layer:eq(0)');

      if ($pageLoading && $pageLoading.length) {

        // Define page update function
        thn.busyRoomsObserver = thn.debounce(function thnBusyRoomsObserver() {
          if (!$pageLoading.is(':visible')) {
            // On mobile, if a room is chosen, it shows the loading layer again
            // Ensure that there're no items in the cart before updating
            if (thn.data.media.name === 'mobile') {
              if (!thn.parseNumber($('.elementInCart').text())) {
                ctx.widget.update();
              }
            } else {
              ctx.widget.update();
            }
          }
        }, 250);

        // Start observation
        thn.observeDom($pageLoading.get(0), thn.busyRoomsObserver, {
          childList: false,
          subtree: false,
          characterData: false,
          attributes: true,
          attributeFilter: ['style', 'class'],
        });

        thn.pageUnload(function () {
          thn.observeDom($pageLoading.get(0), thn.busyRoomsObserver);
          delete thn.busyRoomsObserver;
        });
      }
    }
  };

  /**
     * @memberOf module:bs_240
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    // When there is no availability, some properties change the URL and selectors
    // so it must be added to the conditional so that it initializes the PW and detects it as "No rooms: yes".
    const noRooms = window.location.pathname?.match(/noresults/);

    if (!$) { return widgetData; }

    if (window.location.hostname.match('secure.hotelwebservice.com')) {
      // Dates
      if (thn.data.media.name === 'mobile') {
        if (window.checkAvailabilityData && window.checkAvailabilityData.dtArrival && window.checkAvailabilityData.dtDeparture) {
          widgetData.dateBegin = window.checkAvailabilityData.dtArrival;
          widgetData.dateEnd = window.checkAvailabilityData.dtDeparture;
        } else if ($('.arrival-selector').length && $('.departure-selector').length) {
          widgetData.dateBegin = translateDate($('.arrival-selector').text().trim(), thn.data.language || 'en');
          widgetData.dateEnd = translateDate($('.departure-selector').text().trim(), thn.data.language || 'en');
        }
      } else {
        widgetData.dateBegin = ($('#arrival').val() || '').replace(/-/g, '/');
        widgetData.dateEnd = ($('#departure').val() || '').replace(/-/g, '/');
      }

      // Guests, Adults & Children
      widgetData.adults = thn.parseNumber($('.adultselector:eq(1)').val()) || 2;
      widgetData.children = thn.parseNumber($('.childnumberselector:eq(0)').text().trim()) || 0;
      widgetData.guests = widgetData.adults + widgetData.children;

      // Prices & Currency || No Rooms
      const priceSelector = thn.data.media.name === 'mobile' ? '.mob-select-room' : '.priceValue';
      const prices = $(priceSelector).map((idx, price) => thn.parseNumber($(price).text())).toArray();

      if (prices.length) {
        widgetData.price = Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        if (window.axConfig && window.axConfig.currency) {
          widgetData.currency = window.axConfig.currency;
        } else if ($('.currency:eq(0)').length) {
          widgetData.currency = thn.getCurrencyCode($('.currency:eq(0)').text().trim());
        }
        if (widgetData.price && widgetData.currency) {
          widgetData.set = true;
        }
      } else if ($('#resultContainer .alert-danger').length) {
        widgetData.noRooms = true;
      }
    } else if (document.querySelector('#boxes')) {

      // Dates
      widgetData.dateBegin = (thn.dataLayerHelper.get('checkInDate') || '').replace(/-/g, '/');
      widgetData.dateEnd = (thn.dataLayerHelper.get('checkOutDate') || '').replace(/-/g, '/');

      // Guests, Adults & Children
      widgetData.adults = thn.parseNumber(thn.dataLayerHelper.get('numberOfGuests')) || 2;
      widgetData.children = 0;
      widgetData.guests = widgetData.adults + widgetData.children;

      // Prices & Currency || No Rooms
      const prices = [...document.querySelectorAll('li>strong')].map((el) => thn.parseNumber(el.textContent));
      if (prices.length) {
        widgetData.price = (Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)).toFixed(2);
        widgetData.currency = document.querySelector('.currency-converter>select>option').textContent;
        widgetData.set = true;
      } else {
        widgetData.noRooms = true;
      }
    } else if (document.querySelector('#hypBreadcrumbItem, .mobile_breadcrumbs') || noRooms) {

      // Dates
      widgetData.dateBegin = (window.$IBE_checkInDate || '').replace(/-/g, '/');
      widgetData.dateEnd = (window.$IBE_checkOutDate || '').replace(/-/g, '/');

      // Guests, Adults & Children
      widgetData.adults = thn.parseNumber(window.$IBE_numberOfAdults) || 2;
      widgetData.children = thn.parseNumber(window.$IBE_numberOfChildren) || 0;
      widgetData.guests = widgetData.adults + widgetData.children;

      // Prices & Currency || No Rooms
      let price = [...document.querySelectorAll('.accommodation_large_number.display_inline_block')].map((el) => thn.parseNumber(el.textContent));
      price = Math.min(...price);
      const currencyMatch = ((document.querySelector('#currencyMenuToggle') || {}).textContent || '');
      const currencyToCheck = (thn.data.media.name === 'mobile') ? currencyMatch : currencyMatch.match(/\(\w*(.)\)/) && currencyMatch.match(/\(\w*(.)\)/)[1];
      let currency = (currencyToCheck && thn.parseCurrency(currencyToCheck)) || window.$IBE_bookingCurrency;

      let nights;
      if (widgetData.dateBegin && widgetData.dateEnd) {
        nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      }
      // If one of the values above are wrong we are going to take objects provided by the BE itself. (We don't take this values by default because don't change their content if user change currency)
      // The price objects can be with taxes or without taxes, whichever the case of both, that's the price they show in the DOM, so we should adapt it
      const showWithTaxes = [1014159, 1016860]; // Hotel i31 & Hotel Augusta Augsburg shows the price with taxes (same price as in their DOM) as BAR
      if ((!price || !currency) && showWithTaxes.includes(thn.data.propertyId) && window.$IBE_averageDailyRate && window.$IBE_bookingCurrency && window.$IBE_bookingTotalWithTaxes) {
        this.logger.debug('No price or not currency obtained. Using fallback.');
        price = showWithTaxes.includes(thn.data.propertyId) ? window.$IBE_bookingTotalWithTaxes : window.$IBE_averageDailyRate;
        currency = window.$IBE_bookingCurrency;
      }

      if (price && currency && nights) {
        widgetData.price = (price / nights).toFixed(2);
        widgetData.currency = currency;
        widgetData.set = true;
      } else if (noRooms) {
        widgetData.noRooms = true;
      }
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_240
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    if (!$) { return widgetData; }

    widgetData.dateBegin = thn.widgets.price.data.dateBegin || (window.$IBE_checkInDate || '').replace(/-/g, '/');
    widgetData.dateEnd = thn.widgets.price.data.dateEnd || (window.$IBE_checkOutDate || '').replace(/-/g, '/');

    const $bookingIdSelector = thn.data.media.name === 'mobile' ? '#mBookingResult-modal .reservation' : '.finalBookingOverview  .reservation';
    const bookingId = (($($bookingIdSelector).text() || '').split(':') || [])[1];
    widgetData.bookingId = (bookingId && bookingId.trim()) || window.$IBE_bookingCode;

    if (window.$IBE_converted_bookingTotalWithTaxes && window.$IBE_converted_bookingCurrency) {
      // First we will try to obtain the price & currency data converted to the correct currency in the window object
      thn.logger.info('--- Using window object to obtain converted price and currency ---');
      widgetData.price = thn.parseNumber(window.$IBE_converted_bookingTotalWithTaxes);
      widgetData.currency = window.$IBE_converted_bookingCurrency;
    } else if (window.$IBE_bookingTotalWithTaxes && window.$IBE_bookingCurrency) {
      // If we can't, we try to obtain the unconverted data
      thn.logger.info('--- Using window object to obtain unconverted price and currency ---');
      widgetData.price = thn.parseNumber(window.$IBE_bookingTotalWithTaxes);
      widgetData.currency = window.$IBE_bookingCurrency;
    } else {
      // If the data from the window object is not present, we will use the legacy version
      thn.logger.info('--- Using Legacy version for obtaining BC price and currency ---');
      widgetData.price = thn.parseNumber($('#totalDataPrice h3').text());
      widgetData.currency = ctx.widget.data.currency;
    }

    return widgetData;
  };

  return engine;

}

export { factory };
